import React from 'react'
import Slider from 'react-slick'

import Audio from './Audio'
import { makeArrow, MAX_REGULAR_THUMBS } from './utils'
import Thumb from './Thumb'

import './slick-1.6.0.min.css'
import './Photos.scss'

import { PhotoProps } from '../../../shared/Module'

interface ThumbSliderProps {
  // As sub slider and main slider are loaded at the same time, refs are not
  // created on first render. Therefore ref cannot be marked as required.
  // `object` goes for `null`.
  mainSliderRef: any
  sliderRef: any
  slides: Array<{
    alt?: string
    audio?: string
    main: PhotoProps
    thumb: PhotoProps
    video?: string
  }>
}

const ThumbSlider = ({
  mainSliderRef,
  sliderRef,
  slides,
}: ThumbSliderProps) => {
  const PrevArrow = makeArrow({
    alt: 'Photo précédente',
    direction: 'previous',
  })
  const NextArrow = makeArrow({
    alt: 'Photo suivante',
    direction: 'next',
  })

  return (
    <Slider
      asNavFor={mainSliderRef}
      className='c-glide__thumbnail-wrapper c-glide__thumbnail_wrapper--subslider u-hidden@us'
      cssEase='cubic-bezier(0.165, 0.840, 0.440, 1.000)'
      focusOnSelect
      infinite={false}
      nextArrow={<NextArrow />}
      prevArrow={<PrevArrow />}
      lazyLoad='progressive'
      ref={sliderRef}
      slidesToShow={MAX_REGULAR_THUMBS}
      slidesToScroll={MAX_REGULAR_THUMBS}
      speed={400}
    >
      {slides.map(({ alt, audio, thumb }, index) =>
        audio ? (
          <Audio key={index} url={audio} thumb />
        ) : (
          <Thumb key={index} alt={alt} {...thumb} />
        )
      )}
    </Slider>
  )
}

export default ThumbSlider
